@import (reference) '../../../../../../constants/spacing.module.less';

.actionButtonIconClass {
  margin: @space-4 @space-8 0 0;
}

.messageEditingSections {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: @space-16;
  height: fit-content;
  width: 100%;
}

.returnsTabTitle {
  display: flex;
  gap: @space-8;
}

h3.title {
  margin: 0;
}

.emailSettingsSection {
  width: 50%;
}
